import Multimedia from "@sharedComponents/multimedia";

import QuantitySelector from "@components/store/product-detail/shared/quantity-selector";

import useStoreCurrencyConverter from "@hooks/currency/use-store-currency-converter";

import { getProductColorsAndSizes, getProductAllVariantImages } from "@helpers/product-details";
import { getPriceFromBulkProduct } from "@stadium/helpers/product/utils";
import { getMasterVariant } from "@helpers/products/search";

import NoImage from "@assets/images/no-image.svg";

import defaultStyles from "./main.module.scss";

const DEFAULT_OBJECT = {};

const KitLineItem = ({
  lineItem,
  handleCart,
  showColors = true,
  showInventory = true,
  styles = defaultStyles,
}) => {
  const { id, total, product, brand, quantity } = lineItem || DEFAULT_OBJECT;

  const {
    name,
    priceIn,
    variantsIncludingMaster = [],
    masterVariant: productMasterVariant,
    hasTierPricing,
    bulkAvailable,
  } = product || DEFAULT_OBJECT;

  const { formatPriceInDisplayStoreCurrency } = useStoreCurrencyConverter();

  const masterVariant = getMasterVariant(variantsIncludingMaster);
  const variantImages = getProductAllVariantImages(variantsIncludingMaster);

  const { colorOptionsValue } = getProductColorsAndSizes(product);

  const { inLocker, inTransit } = total || DEFAULT_OBJECT;

  const brandName = brand?.name || "";

  const productImage = variantImages?.[0] || NoImage;

  const getDisplayPrice = () => {
    if (bulkAvailable || hasTierPricing) {
      const value = getPriceFromBulkProduct(productMasterVariant, quantity);
      return formatPriceInDisplayStoreCurrency(value);
    }
    return formatPriceInDisplayStoreCurrency(
      productMasterVariant?.priceIn || masterVariant?.priceIn || priceIn,
    );
  };

  const renderQuantity = () => {
    return (
      <QuantitySelector
        quantity={quantity}
        setQuantity={handleCart}
        restrictZeroInput={true}
        className="defaultStyle"
      />
    );
  };

  return (
    <div className={styles.productListRow} key={id}>
      <div className={styles.productImgContainer}>
        <Multimedia
          type="image"
          src={productImage}
          alt="Not Found"
          height={128}
          width={128}
          className={styles.productImg}
        />
      </div>
      <div className={styles.productColDesc}>
        <div className={styles.productCol}>
          <div className={styles.productBrand}>{brandName}</div>
          <div className={styles.productName}>{name}</div>
          {showInventory && Boolean(inLocker || inTransit) && (
            <div className={styles.productQty}>
              {inLocker || inTransit} IN {inLocker ? "LOCKER" : "TRANSIT"}
            </div>
          )}
        </div>

        <div className={styles.productColPrice}>{getDisplayPrice()}</div>

        {showColors && colorOptionsValue?.length > 1 && (
          <div className={styles.colorContainer}>
            Color:
            <div className={styles.colorList}>
              {colorOptionsValue.map(({ name }) => (
                <span className={styles.colorOption} style={{ background: name }} key={name} />
              ))}
            </div>
          </div>
        )}
      </div>
      <div className={styles.qtyParentBlock}>{renderQuantity()}</div>

      <div className={styles.productColCta}>
        <span className={styles.removeProduct} onClick={() => handleCart()} />
      </div>
    </div>
  );
};

export default KitLineItem;
